import { useStaticQuery, graphql } from "gatsby"

export const useTopMenuData = () => {
  const wordpress = useStaticQuery(graphql`
    query getTopMenu {
      allWpMenu(filter: {id: {eq: "dGVybToy"}}) {
        nodes {
          id
          menuItems {
            nodes {
              id
              label
              url
              cssClasses
              childItems {
                nodes {
                  url
                  label
                  cssClasses
                  childItems {
                    nodes {
                      label
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return wordpress.allWpMenu.nodes[0].menuItems.nodes
}
